<template>
  <div v-click-outside="() => (showDropdown = false)" class="dropdown-button">
    <IconButton
      form="transparent"
      icon-position="right"
      icon="chevron-down"
      class="icon-button"
      @click="showDropdown = !showDropdown"
    >
      <slot />
    </IconButton>
    <Transition name="fade">
      <ul v-if="showDropdown" class="dropdown">
        <li
          v-for="(option, index) in options"
          :key="index"
          class="option"
          :class="{ 'option--active': option.value === activeOption }"
        >
          <button @click="handleOptionClick(option.value)">
            {{ option.label }}
          </button>
        </li>
      </ul>
    </Transition>
  </div>
</template>

<script>
import IconButton from "@/components/IconButton.vue";

export default {
  name: "DropdownButton",
  components: {
    IconButton,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    activeOption: {
      type: String,
      default: null,
    },
  },
  emits: ["change"],
  data() {
    return {
      showDropdown: false,
    };
  },
  methods: {
    handleOptionClick(value) {
      this.showDropdown = false;
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.dropdown-button {
  position: relative;
}

.dropdown {
  position: absolute;
  top: 42px;
  right: 0;
  color: $color-black;
  border-radius: 0px 0px 0px 8px;
  background-color: $color-white;
  box-shadow: 2px 4px 10px 0px rgba($color-black, 0.04);
  padding: 7px 20px;
  display: inline-block;
  margin: 0;
  list-style: none;
  z-index: 1;

  li {
    margin-bottom: 4px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .option {
    &--active,
    :hover {
      opacity: 0.56;
    }

    button {
      display: block;
      width: 100%;
      text-align: right;
      @include utility-label(12px);
      background: none;
      border: none;
      padding: 0;
      outline: none;
      white-space: nowrap;
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
